import { defineGridPlugin } from '@bingads-webui/projection-grid-plugin';

export const chartPlugin = defineGridPlugin(
  'chart',
  [
    'config',
    'toolbar',
  ],
  (config, toolbar) => {
    const menuId = 'button-chart-toggle';
    const toolbarEditor = toolbar.gridToolbarGroup.toolbarWithItem(menuId);
    const {
      chart: {
        toggleChartToolbar,
      },
    } = config.plugins;

    toolbarEditor.update({
      type: 'button',
      id: menuId,
      classes: ['btn', 'chart-icon'],
      onClick: () => {
        toggleChartToolbar();
      },
    });
  }
);
